<template>
<div>
    <modal-dialog :is-open="isOpen" v-on:close-dialog="onCloseDialog($event)"></modal-dialog>

    <v-menu origin="center center" bottom left>
        <v-btn slot="activator" icon>
            <v-icon>more_vert</v-icon>
        </v-btn>

        <v-list>
            <v-list-tile v-for="(item, i) in items" :key="i" @click="onClick({action: item.action, folderId})">
                <v-list-tile-action class="interface-mail-folder-menu__item-icon">
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
        </v-list>
    </v-menu>
</div>
    
</template>

<script>
    import ModalDialog from './ModalDialog'
    import randomId from '@/utils/randomId.js'

    export default {
        name: 'interface-mail-folder-menu',
        props: {
            folderId: [Number,String],
            model: Object
        },
        data () {
            return {
                items: [
                    {
                        title: 'Создать папку',
                        icon: 'create_new_folder',
                        action: 'create'
                    },
                    {
                        title: 'Удалить папку',
                        icon: 'delete',
                        action: 'delete'
                    }
                ],
                newFolderName: '',
                isOpen: false,
                newFolderParentId: null
                }
        },
        methods: {
            onClick(data) {
                if (data.action == 'create') {
                    this.openDialog()
                } else if (data.action == 'delete') {
                    let res = confirm('Вы действительно хотите удалить папку?')
                    res && this.model.parentFolder.folders.forEach((folder, idx) => {
                        if (folder.id == this.folderId) {
                            this.model.parentFolder.folders.splice(idx, 1)
                        }
                    })
                }
            },
            onCloseDialog(data){
                this.isOpen = false
                if (data.create && data.folderName) {
                this.newFolderName = data.folderName
                this.model.folder.folders.push({
                        title: this.newFolderName,
                        id: randomId(),
                        parentFolder: this.model.folder.id,
                        sorted: true,
                        folders:[]
                    })
                }
            },
            onAction(data) {
                if (data.action == 'create') {
                    this.newFolderParentId = data.folderId
                }
            },
            openDialog() {
                this.isOpen = true
            }
        },
        components: {
            ModalDialog

        },
        computed: {}
    }
</script>

<style lang="stylus">
    .interface-mail-folder-menu {
        &__item-icon {
            min-width 32px
        }
    }
</style>
